import React, { Component } from 'react';

import loginPageCss from "../css/loginPage.module.css";

import SingleButton from "../../../component/button/SingleButton";
import TextInput from "../../../component/input/TextInput";

import * as apiUtil from '../../../util/apiUtil';

class PhoneAuthInputComp extends Component {
    constructor(props) {
        super(props);

        this.danalVerify = this.danalVerify.bind(this);
        this.submitForm = this.submitForm.bind(this);

        this.state = {
            TID: '',
            num: ''
        }
    }

    shouldComponentUpdate(nextProps, nextState, nextContext) {
        return (
            this.state.TID !== nextState.TID
            || this.props.num !== nextProps.num
        )
    }

    danalVerify() {
        apiUtil.asyncRequest({
            url: '/api/bizchat/user/phone/ready',
            method: apiUtil.requestMethod.POST,
            success: (result) => {
                this.setState({TID: result}, () => this.submitForm());
            }
        })
    }

    submitForm() {
        const { handlePhoneVerify } = this.props;
        const form = document.getElementById('authForm');
        const formData = new FormData(form);

        // 팝업창 열기
        const popup = window.open('', '_blank', 'width=400,height=600');
        const formAction = form.getAttribute('action');

        popup.document.open();
        popup.document.write(`
            <html>
            <head><title>폼 제출 결과</title></head>
            <body>
                <form action="${formAction}" method="POST" target="_self">
                    ${Array.from(formData.entries()).map(([name, value]) => `
                        <input type="hidden" name="${name}" value="${value}" />
                    `).join('')}
                    <button type="submit">Submit</button>
                </form>
                <script>
                    document.forms[0].submit();
                </script>
            </body>
            </html>
        `);
        popup.document.close();

        const checkPopupClosed = setInterval(() => {
            if (popup.closed) {
                apiUtil.asyncRequest({
                    url: `/api/bizchat/user/phone/read?TID=${this.state.TID}`,
                    method: apiUtil.requestMethod.POST,
                    success: async (result) => {
                        if(result.inspectionStatus === "success") {
                            handlePhoneVerify(result);
                        }
                    }
                })
                clearInterval(checkPopupClosed);
            }
        }, 1000);
    }// end submitformat


    render() {
        const { TID } = this.state;
        const { num } = this.props;
        const { danalVerify } = this;

        return (
            <>
                <div className="row align-items-center mt-3">
                    <div className='col-sm-3'>
                        <label htmlFor="phone">휴대폰 인증<span className='text-danger'>*</span></label>
                    </div>
                    <div className='col-sm-9 d-flex'>
                        <TextInput
                            className={`form-control me-2`}
                            type="tel"
                            id="phone"
                            value={num}
                            readOnly={true}
                            placeholder="휴대폰 인증을 진행해 주세요"
                        />
                        <SingleButton
                            className={`${loginPageCss["btn"]} btn btn-outline-primary`}
                            label="휴대폰 인증"
                            handleClick={danalVerify}
                        />
                    </div>
                </div>
                <div className="row align-items-center">
                    <div className='col-sm-3'></div>
                    <div className='col-auto'>
                        <small className='text-muted'>번호는 - 없이 11자리 연속으로 작성해주세요</small>
                    </div>
                </div>
                <form id={"authForm"} className={"visually-hidden"} action="https://wauth.teledit.com/Danal/WebAuth/Web/Start.php" method="POST">
                    <input name={"TID"} type="text" value={TID} readOnly={true}/>
                    <input name={"BgColor"} type="text" value={"00"} readOnly={true}/>
                    <input name={"IsCharSet"} type="text" value={"UTF-8"} readOnly={true}/>
                    <button className={"btn btn-primary"} type={"submit"}>submit</button>
                </form>
            </>
        )
    }
}

export default PhoneAuthInputComp;
